import { Link, useParams } from "react-router-dom";
import { DirectionBadge, LiveBadge } from "../components/Badges";
import { ErrorBanner } from "../components/ErrorBanner";
import { useApi } from "../hooks/useApi";
import { dash, formatTime, trainLabel } from "../api/format";
import type { TrainDetail } from "../api/types";

export function TrainSchedule() {
  const { id } = useParams();
  const trainId = Number(id);
  const path = Number.isInteger(trainId) && trainId > 0 ? `/v1/trains/${trainId}` : null;
  const { data, error, loading, retry } = useApi<TrainDetail>(path);

  if (!path) return <div className="page"><p>Invalid train id.</p></div>;

  const stops = data?.stations ? [...data.stations].sort((a, b) => a.order_number - b.order_number) : [];

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <Link to="/trains" className="muted">
            ← Trains
          </Link>
          <h1>{data ? trainLabel(data) : "Train schedule"}</h1>
          {data?.train_name_ur ? <p className="urdu muted">{data.train_name_ur}</p> : null}
          {data?.description ? <p className="muted">{data.description}</p> : null}
        </div>
        <div className="actions">
          {data ? (
            <>
              <DirectionBadge direction={data.direction} />
              <LiveBadge live={Boolean(data.is_live)} />
              <Link className="btn" to={`/map/${data.train_id}`}>
                Track on map
              </Link>
            </>
          ) : null}
        </div>
      </div>
      <ErrorBanner error={error} onRetry={retry} />
      {loading ? <p className="muted">Loading schedule…</p> : null}
      {data && stops.length === 0 ? <p className="muted">No stops listed.</p> : null}
      {stops.length > 0 ? (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Station</th>
                <th>Arrive</th>
                <th>Depart</th>
                <th>Crossed</th>
                <th>Delay</th>
              </tr>
            </thead>
            <tbody>
              {stops.map((s) => (
                <tr key={`${s.station_id}-${s.order_number}`} className={s.is_crossed ? "row-crossed" : undefined}>
                  <td>{s.order_number}</td>
                  <td>
                    <Link to={`/stations/${s.station_id}`}>{s.station_name}</Link>
                    <div className="muted">{dash(s.city)}</div>
                  </td>
                  <td>{formatTime(s.arrival_time)}</td>
                  <td>{formatTime(s.departure_time)}</td>
                  <td>{s.is_crossed ? dash(s.crossed_date_time) : "—"}</td>
                  <td>{s.delay_in_minutes == null ? "—" : `${s.delay_in_minutes} min`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
